import DeliveryDetails from '../../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withMapList from '../../../../elements/HOC/withMapList'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import React from 'react'
import { Checkbox, Col, Form, Row } from 'antd'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout } from '../../../../modules/FormItems'
import { compose } from 'recompose'

function DeliveryRouteForm (props) {
  const { line, list, cargo } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form
  const stops = get(cargo, 'stops', [])

  const StopsSelect = compose(
    withData({ data: stops }),
    withSort,
    withMapList((l) => {
      const status = l.isStart ? 'Start' : l.isEnd ? 'End' : 'Intermediate Stop'
      return {
        ...l,
        display: `[${status}] 
        ${get(l, 'location.address.label')}, 
        ${get(l, 'location.country')}, 
        ${get(l, 'location.location')}`,
      }
    }),
  )(CustomSelect)
  return (
    <Form>
      <Row>
        <FormSectionTitle title={'Start oF the Route'}/>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Start Stop'}>
            {getFieldDecorator('start.shearedID', {
              initialValue: get(line, 'start.shearedID'),
              rules: [{ required: true, message: 'Please Select a A Start Point!' }],
            })(<StopsSelect keyAtr={'shearedID'} valueAtr={'display'} placeholder={'Select an enquiry'}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <FormSectionTitle title={'End oF the Route'}/>
        <Row>
          <Col span={12}>
            <Form.Item label="Existing Route" {...defaultFormItemLayout}>
              {getFieldDecorator('isExisting', {
                initialValue: true,
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Final Stop" {...defaultFormItemLayout}>
              {getFieldDecorator('isEnd', {
                initialValue: true,
                valuePropName: 'checked',
              })(<Checkbox/>)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {getFieldValue('isExisting') ? (
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label={'Start Stop'}>
                {getFieldDecorator('end.shearedID', {
                  initialValue: get(line, 'end.shearedID'),
                  rules: [
                    {
                      required: true,
                      validator: (rule, value, callback) => {
                        if (getFieldValue('start.shearedID') === value) callback('You can\'t select the same point')
                        callback()
                      },
                      message: `You can't select the same point`,
                    },
                  ],
                })(<StopsSelect keyAtr={'shearedID'} valueAtr={'display'} placeholder={'Select an enquiry'}/>)}
              </Form.Item>
            </Col>
          ) : (
            <DeliveryDetails
              doc={{}}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'route',
                prefix: 'location',
                hideTitle: true,
                hideDangerous: true,
              }}
            />
          )}
        </Row>
      </Row>
    </Form>
  )
}

DeliveryRouteForm.propTypes = {}
DeliveryRouteForm.defaultProps = {}

export default Form.create()(DeliveryRouteForm)
